(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-player"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var player = document.getElementById('gkp');
    var audio  = document.getElementById('gkp-audio');
    if (!player || !audio) return;

    function $(sel) { return player.querySelector(sel); }

    var fabBtn    = $('.gkp__fab');
    var closeBtn  = $('.gkp__close-btn');
    var songEl    = $('.gkp__song');
    var artistEl  = $('.gkp__artist');
    var seekBar   = $('.gkp__seek');
    var timeCur   = $('.gkp__time--cur');
    var timeDur   = $('.gkp__time--dur');
    var prevBtn   = document.getElementById('gkp-prev');
    var playBtn   = document.getElementById('gkp-play');
    var stopBtn   = document.getElementById('gkp-stop');
    var nextBtn   = document.getElementById('gkp-next');
    var muteBtn   = document.getElementById('gkp-mute');
    var listBtn   = document.getElementById('gkp-list');
    var volSlider = $('.gkp__vol');
    var playlist  = $('.gkp__playlist');
    var iconPlay  = $('.gkp__icon--play');
    var iconPause = $('.gkp__icon--pause');
    var iconVol   = $('.gkp__icon--vol');
    var iconMuted = $('.gkp__icon--muted');
    var coverImg  = $('.gkp__cover-img');
    var coverPh   = $('.gkp__cover-ph');
    var albumEl   = $('.gkp__album');
    var albumImg  = $('.gkp__album-img');
    var tracks    = Array.from(player.querySelectorAll('.gkp__track'));

    var cur     = parseInt(localStorage.getItem('gkp-idx') || '0', 10);
    var playing = false;
    var lastTrackedIdx = -1;

    function trackPlay(title, artist, idx) {
      if (idx === lastTrackedIdx) return;
      lastTrackedIdx = idx;
      try {
        if (window.analytics && typeof window.analytics.publish === 'function') {
          window.analytics.publish('song_play', {
            customData: { song_title: title, artist: artist || 'GanjaKillz', track_index: idx }
          });
        }
      } catch (e) {}
    }

    // Restore volume — default 0.7 (70% of max, 30% below max)
    var savedVol = parseFloat(localStorage.getItem('gkp-vol') || '0.7');
    audio.volume = savedVol;
    volSlider.value = savedVol;

    function fmt(s) {
      var m = Math.floor(s / 60);
      var sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    function setPlaying(v) {
      playing = v;
      iconPlay.style.display  = v ? 'none' : '';
      iconPause.style.display = v ? 'inline' : 'none';
      iconPlay.setAttribute('fill',  v ? '#fff' : '#000');
      iconPause.setAttribute('fill', v ? '#fff' : '#000');
      playBtn.setAttribute('aria-label', v ? 'Pause' : 'Play');
    }

    function highlightTrack(idx) {
      tracks.forEach(function (t, i) {
        t.classList.toggle('gkp__track--active', i === idx);
      });
    }

    function setCover(url) {
      if (url) {
        coverImg.src = url;
        coverImg.style.display = 'block';
        coverPh.style.display  = 'none';
        albumImg.src = url;
        albumEl.classList.add('gkp__album--visible');
      } else {
        coverImg.src = '';
        coverImg.style.display = 'none';
        coverPh.style.display  = '';
        albumImg.src = '';
        albumEl.classList.remove('gkp__album--visible');
      }
    }

    function load(idx, autoplay) {
      if (!tracks[idx]) return;
      cur = idx;
      localStorage.setItem('gkp-idx', String(idx));
      var t = tracks[idx];
      audio.src = t.dataset.src;
      songEl.textContent   = t.dataset.title  || 'Unknown';
      artistEl.textContent = t.dataset.artist || '';
      seekBar.value  = 0;
      timeCur.textContent = '0:00';
      timeDur.textContent = '0:00';
      highlightTrack(idx);
      setCover(t.dataset.cover || '');
      if (autoplay) {
        audio.play().then(function () {
          setPlaying(true);
          trackPlay(t.dataset.title, t.dataset.artist, idx);
        }).catch(function () {});
      }
    }

    function togglePlay() {
      if (!audio.src) { load(cur, true); return; }
      if (playing) {
        audio.pause();
        setPlaying(false);
        localStorage.setItem('gkp-paused', '1');
      } else {
        audio.play().then(function () {
          setPlaying(true);
          localStorage.removeItem('gkp-paused');
          var t = tracks[cur];
          if (t) trackPlay(t.dataset.title, t.dataset.artist, cur);
        }).catch(function () {});
      }
    }

    var card        = $('.gkp__card');
    var collapseBtn = $('.gkp__collapse-btn');

    function collapsePlayer() {
      player.classList.add('gkp--collapsed');
      fabBtn.setAttribute('aria-expanded', 'false');
    }

    function openPlayer() {
      player.classList.remove('gkp--collapsed');
      fabBtn.setAttribute('aria-expanded', 'true');
    }

    // Toggle open / close
    fabBtn.addEventListener('click', openPlayer);
    closeBtn.addEventListener('click', collapsePlayer);
    collapseBtn.addEventListener('click', collapsePlayer);

    // Click outside to close
    document.addEventListener('click', function (e) {
      if (!player.classList.contains('gkp--collapsed') && !player.contains(e.target)) {
        collapsePlayer();
      }
    });

    // Swipe down to close (mobile)
    var swipeStartY = 0;
    var swipeDelta  = 0;

    card.addEventListener('touchstart', function (e) {
      swipeStartY = e.touches[0].clientY;
      swipeDelta  = 0;
      card.style.transition = 'none';
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      swipeDelta = e.touches[0].clientY - swipeStartY;
      if (swipeDelta > 0) {
        card.style.transform = 'translateY(' + Math.min(swipeDelta, 100) + 'px)';
        card.style.opacity   = String(Math.max(1 - swipeDelta / 160, 0.3));
      }
    }, { passive: true });

    card.addEventListener('touchend', function () {
      card.style.transition = '';
      card.style.transform  = '';
      card.style.opacity    = '';
      if (swipeDelta > 64) collapsePlayer();
      swipeDelta = 0;
    });

    // Transport
    playBtn.addEventListener('click', togglePlay);

    stopBtn.addEventListener('click', function () {
      audio.pause();
      audio.currentTime = 0;
      setPlaying(false);
      seekBar.value = 0;
      timeCur.textContent = '0:00';
      localStorage.setItem('gkp-paused', '1');
    });

    prevBtn.addEventListener('click', function () {
      load((cur - 1 + tracks.length) % tracks.length, playing);
    });

    nextBtn.addEventListener('click', function () {
      load((cur + 1) % tracks.length, playing);
    });

    // Mute
    muteBtn.addEventListener('click', function () {
      audio.muted = !audio.muted;
      iconVol.style.display   = audio.muted ? 'none' : '';
      iconMuted.style.display = audio.muted ? '' : 'none';
    });

    // Volume slider
    volSlider.addEventListener('input', function () {
      audio.volume = parseFloat(volSlider.value);
      audio.muted  = false;
      iconVol.style.display   = '';
      iconMuted.style.display = 'none';
      localStorage.setItem('gkp-vol', volSlider.value);
    });

    // Playlist toggle — starts open, click to hide/show
    listBtn.addEventListener('click', function () {
      var nowHidden = playlist.toggleAttribute('hidden');
      listBtn.classList.toggle('gkp__btn--active', !nowHidden);
    });

    // Playlist track click
    tracks.forEach(function (t, i) {
      t.addEventListener('click', function () {
        localStorage.removeItem('gkp-paused');
        load(i, true);
      });
    });

    // Seek bar
    seekBar.addEventListener('input', function () {
      if (audio.duration) {
        audio.currentTime = (seekBar.value / 100) * audio.duration;
      }
    });

    // Audio events
    audio.addEventListener('timeupdate', function () {
      if (!audio.duration) return;
      seekBar.value = (audio.currentTime / audio.duration) * 100;
      timeCur.textContent = fmt(audio.currentTime);
    });

    audio.addEventListener('loadedmetadata', function () {
      timeDur.textContent = fmt(audio.duration);
    });

    audio.addEventListener('ended', function () {
      load((cur + 1) % tracks.length, true);
    });

    // Init — show current track without loading audio
    if (tracks[cur]) {
      songEl.textContent   = tracks[cur].dataset.title  || 'Select a track';
      artistEl.textContent = tracks[cur].dataset.artist || '';
      highlightTrack(cur);
      audio.src = tracks[cur].dataset.src;
      setCover(tracks[cur].dataset.cover || '');
    }

    // Autoplay: homepage only, once per session, not if user manually paused
    var isHome     = window.location.pathname === '/';
    var hadSession = sessionStorage.getItem('gkp-played') === '1';
    var hadPause   = localStorage.getItem('gkp-paused')   === '1';

    if (isHome && !hadSession && !hadPause && tracks.length > 0) {
      audio.play().then(function () {
        setPlaying(true);
        sessionStorage.setItem('gkp-played', '1');
      }).catch(function () {});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-product-player"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.music-playlist').forEach(container => {
    const audioEl = container.querySelector('.music-playlist__audio');
    const items = Array.from(container.querySelectorAll('.music-playlist__item'));
    let currentIndex = -1;

    if (!audioEl || items.length === 0) return;

    function playTrack(index) {
      if (index < 0 || index >= items.length) return;

      currentIndex = index;
      const item = items[index];
      const url = item.dataset.trackUrl;

      if (!url) return;

      audioEl.src = url;
      audioEl.play().catch(err => console.error('Play error:', err));

      items.forEach((el, i) => {
        el.classList.toggle('music-playlist__item--playing', i === index);
      });
    }

    function toggleTrack(index) {
      if (currentIndex === index && !audioEl.paused) {
        audioEl.pause();
        items[index].classList.remove('music-playlist__item--playing');
        currentIndex = -1;
      } else {
        playTrack(index);
      }
    }

    items.forEach((item, index) => {
      item.addEventListener('click', () => toggleTrack(index));
    });

    audioEl.addEventListener('ended', () => {
      if (currentIndex < items.length - 1) {
        playTrack(currentIndex + 1);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
